module.exports = new __parcel__URL__("loadingErrorIcon.3c97c605.svg").toString();